/* eslint-disable */
'use client';
import { stdin_default, } from './chunk-FIPRDO7H.js';

// https :https://framerusercontent.com/modules/Y5k97VBhmEGQt7ZqBxlg/ulL9Q5NnAEbADA5pZ3Vz/v4r4pVd_q.js
import { jsx as _jsx2, jsxs as _jsxs, } from 'react/jsx-runtime';
import {
  addFonts,
  addPropertyControls,
  ComponentViewportProvider,
  ControlType,
  cx,
  getFonts,
  getFontsFromSharedStyle,
  Link,
  RichText,
  useComponentViewport,
  useLocaleInfo,
  useVariantState,
  withCSS,
} from 'unframer';
import { LayoutGroup, motion, MotionConfigContext, } from 'unframer';
import * as React from 'react';

// https :https://framerusercontent.com/modules/WGudXt6HCo0BLMCF8GbW/byXb9EeLOcLMdrePIGdS/Debug.js
import { jsx as _jsx, } from 'react/jsx-runtime';

// https :https://framer.com/m/framer/store.js@^1.0.0
import { useEffect, useState, } from 'react';
import { Data, useObserveData, } from 'unframer';
function createStore(state1,) {
  const dataStore = Data({ state: Object.freeze({ ...state1, },), },);
  const setDataStore = (newState,) => {
    if (typeof newState === 'function') {
      newState = newState(dataStore.state,);
    }
    dataStore.state = Object.freeze({ ...dataStore.state, ...newState, },);
  };
  let storeState = typeof state1 === 'object' ? Object.freeze({ ...state1, },) : state1;
  const storeSetters = /* @__PURE__ */ new Set();
  const setStoreState = (newState,) => {
    if (typeof newState === 'function') {
      newState = newState(storeState,);
    }
    storeState = typeof newState === 'object' ? Object.freeze({ ...storeState, ...newState, },) : newState;
    storeSetters.forEach((setter,) => setter(storeState,));
  };
  function useStore2() {
    const [state, setState,] = useState(storeState,);
    useEffect(() => {
      storeSetters.add(setState,);
      return () => storeSetters.delete(setState,);
    }, [],);
    if (useObserveData() === true) {
      useObserveData();
      return [dataStore.state, setDataStore,];
    } else {
      return [state, setStoreState,];
    }
  }
  return useStore2;
}

// https :https://framerusercontent.com/modules/WGudXt6HCo0BLMCF8GbW/byXb9EeLOcLMdrePIGdS/Debug.js
var useStore = createStore({ background: '#0099FF', },);
function withShowProps(Component2,) {
  return (props,) => {
    console.log('props', Component2 === null || Component2 === void 0 ? void 0 : Component2.displayName, props,);
    return /* @__PURE__ */ _jsx(Component2, { ...props, },);
  };
}

// https :https://framerusercontent.com/modules/gfCqz150qLUp8Sv9WuYa/Bv2pIAWPL3RKiu0pg4zT/N4cH5VlsQ.js
import { fontStore as e, } from 'unframer';
e.loadWebFontsFromSelectors([],);
var fonts = [];
var css = [
  '.framer-wTDMW .framer-styles-preset-1sbcrqm:not(.rich-text-wrapper), .framer-wTDMW .framer-styles-preset-1sbcrqm.rich-text-wrapper a { --framer-link-current-text-decoration: none; --framer-link-hover-text-color: var(--token-aa00c859-9e35-4938-802e-5067ae674749, #404245) /* {"name":"dark/500"} */; --framer-link-hover-text-decoration: underline; --framer-link-text-color: var(--token-61e5ee56-3594-4358-94d0-c3752e3672e3, #181c23); --framer-link-text-decoration: underline; }',
];
var className = 'framer-wTDMW';

// https :https://framerusercontent.com/modules/Y5k97VBhmEGQt7ZqBxlg/ulL9Q5NnAEbADA5pZ3Vz/v4r4pVd_q.js
var LogoFonts = getFonts(stdin_default,);
var MotionDivWithShowProps = withShowProps(motion.div,);
var cycleOrder = ['uyOzMAJQy', 'jJWwQuLAJ',];
var serializationHash = 'framer-CH87R';
var variantClassNames = { jJWwQuLAJ: 'framer-v-75wkdn', uyOzMAJQy: 'framer-v-1p2dk03', };
function addPropertyOverrides(overrides, ...variants) {
  const nextOverrides = {};
  variants === null || variants === void 0
    ? void 0
    : variants.forEach((variant,) => variant && Object.assign(nextOverrides, overrides[variant],));
  return nextOverrides;
}
var transition1 = { damping: 60, delay: 0, mass: 1, stiffness: 500, type: 'spring', };
var transition2 = { damping: 30, delay: 0, mass: 1, stiffness: 400, type: 'spring', };
var animation = { opacity: 0.3, rotate: 0, rotateX: 0, rotateY: 0, scale: 1, skewX: 0, skewY: 0, transition: transition2, };
var Transition = ({ value, children, },) => {
  const config = React.useContext(MotionConfigContext,);
  const transition = value !== null && value !== void 0 ? value : config.transition;
  const contextValue = React.useMemo(() => ({ ...config, transition, }), [JSON.stringify(transition,),],);
  return /* @__PURE__ */ _jsx2(MotionConfigContext.Provider, { value: contextValue, children, },);
};
var Variants = motion(React.Fragment,);
var humanReadableVariantMap = { desktop: 'uyOzMAJQy', mobile: 'jJWwQuLAJ', };
var getProps = ({ height, id, width, ...props },) => {
  var _humanReadableVariantMap_props_variant, _ref;
  return {
    ...props,
    variant:
      (_ref =
            (_humanReadableVariantMap_props_variant = humanReadableVariantMap[props.variant]) !== null &&
              _humanReadableVariantMap_props_variant !== void 0
              ? _humanReadableVariantMap_props_variant
              : props.variant) !== null && _ref !== void 0
        ? _ref
        : 'uyOzMAJQy',
  };
};
var createLayoutDependency = (props, variants,) => variants.join('-',) + props.layoutDependency;
var Component = /* @__PURE__ */ React.forwardRef(function (props, ref,) {
  const { activeLocale, setLocale, } = useLocaleInfo();
  const { style, className: className2, layoutId, variant, ...restProps } = getProps(props,);
  const { baseVariant, classNames, gestureVariant, setGestureState, setVariant, variants, } = useVariantState({
    cycleOrder,
    defaultVariant: 'uyOzMAJQy',
    variant,
    variantClassNames,
  },);
  const layoutDependency = createLayoutDependency(props, variants,);
  const ref1 = React.useRef(null,);
  const defaultLayoutId = React.useId();
  const sharedStyleClassNames = [className,];
  const componentViewport = useComponentViewport();
  return /* @__PURE__ */ _jsx2(LayoutGroup, {
    id: layoutId !== null && layoutId !== void 0 ? layoutId : defaultLayoutId,
    children: /* @__PURE__ */ _jsx2(Variants, {
      animate: variants,
      initial: false,
      children: /* @__PURE__ */ _jsx2(Transition, {
        value: transition1,
        children: /* @__PURE__ */ _jsx2(MotionDivWithShowProps, {
          ...restProps,
          className: cx(serializationHash, ...sharedStyleClassNames, 'framer-1p2dk03', className2, classNames,),
          'data-framer-name': 'desktop',
          layoutDependency,
          layoutId: 'uyOzMAJQy',
          onHoverEnd: () => setGestureState({ isHovered: false, },),
          onHoverStart: () => setGestureState({ isHovered: true, },),
          onTap: () => setGestureState({ isPressed: false, },),
          onTapCancel: () => setGestureState({ isPressed: false, },),
          onTapStart: () => setGestureState({ isPressed: true, },),
          ref: ref !== null && ref !== void 0 ? ref : ref1,
          style: { backgroundColor: 'rgb(255, 255, 255)', ...style, },
          ...addPropertyOverrides({ jJWwQuLAJ: { 'data-framer-name': 'mobile', }, }, baseVariant, gestureVariant,),
          children: /* @__PURE__ */ _jsxs(motion.div, {
            className: 'framer-sg7vss',
            layoutDependency,
            layoutId: 'k5iqkzgt5',
            children: [
              /* @__PURE__ */ _jsxs(motion.div, {
                className: 'framer-1n2n1ru',
                layoutDependency,
                layoutId: 'z46oERpeI',
                children: [
                  /* @__PURE__ */ _jsxs(motion.div, {
                    className: 'framer-lx8aev',
                    layoutDependency,
                    layoutId: 'lyXgx0HYc',
                    children: [
                      /* @__PURE__ */ _jsx2(ComponentViewportProvider, {
                        children: /* @__PURE__ */ _jsx2(motion.div, {
                          className: 'framer-r70520-container',
                          layoutDependency,
                          layoutId: 'nl7_6MYZP-container',
                          children: /* @__PURE__ */ _jsx2(stdin_default, {
                            height: '100%',
                            id: 'nl7_6MYZP',
                            layoutId: 'nl7_6MYZP',
                            width: '100%',
                          },),
                        },),
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsxs(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'left',
                              '--framer-text-color':
                                'var(--extracted-r6o4lv, var(--token-c97db126-8e49-4dfa-8a8a-566d4fa3e425, rgb(0, 0, 0)))',
                            },
                            children: [
                              /* @__PURE__ */ _jsx2(motion.span, {
                                style: { '--framer-text-color': 'var(--extracted-1w3ko1f, rgb(0, 0, 0))', },
                                children: 'The editing platform for Markdown. ',
                              },),
                              'Make your markdown files editable by everyone. Let non technical team members write docs, save 1000+ hours of your engineers time!',
                            ],
                          },),
                        },),
                        className: 'framer-414qf4',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'LjIVDBAiY',
                        style: {
                          '--extracted-1w3ko1f': 'rgb(0, 0, 0)',
                          '--extracted-r6o4lv': 'var(--token-c97db126-8e49-4dfa-8a8a-566d4fa3e425, rgb(0, 0, 0))',
                          '--framer-link-text-color': 'rgb(0, 153, 255)',
                          '--framer-link-text-decoration': 'underline',
                          opacity: 0.8,
                        },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                    ],
                  },),
                  /* @__PURE__ */ _jsx2(motion.div, {
                    className: 'framer-fhvc5u',
                    layoutDependency,
                    layoutId: 'mZKu8HSF0',
                    children: /* @__PURE__ */ _jsx2(Link, {
                      href: 'x.com/holocronhq',
                      openInNewTab: true,
                      children: /* @__PURE__ */ _jsx2(motion.a, {
                        className: 'framer-1v3h9o6 framer-einq92',
                        'data-framer-name': 'X',
                        layoutDependency,
                        layoutId: 'AsAs57CS_',
                        style: { opacity: 0.5, },
                        whileHover: animation,
                      },),
                    },),
                  },),
                ],
              },),
              /* @__PURE__ */ _jsxs(motion.div, {
                className: 'framer-16iri5q',
                layoutDependency,
                layoutId: 'IrYyFQ8VO',
                children: [
                  /* @__PURE__ */ _jsxs(motion.div, {
                    className: 'framer-6cyidk',
                    layoutDependency,
                    layoutId: 'dh_JaxF5h',
                    children: [
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy03MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '700',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1em',
                              '--framer-text-alignment': 'center',
                            },
                            children: 'Product',
                          },),
                        },),
                        className: 'framer-d3ff5u',
                        fonts: ['GF;DM Sans-700',],
                        layoutDependency,
                        layoutId: 'jESSq7_oT',
                        style: { '--framer-link-text-color': 'rgb(0, 153, 255)', '--framer-link-text-decoration': 'underline', },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/?',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Home',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-15ohrsh',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'BPAMQWAgq',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/#pricing',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Pricing',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-13i6r7z',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'K6M5EeBvx',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                    ],
                  },),
                  /* @__PURE__ */ _jsxs(motion.div, {
                    className: 'framer-cm4cza',
                    layoutDependency,
                    layoutId: 'WuMeY7d50',
                    children: [
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy03MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '700',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1em',
                              '--framer-text-alignment': 'center',
                            },
                            children: 'Company',
                          },),
                        },),
                        className: 'framer-1h5oztg',
                        fonts: ['GF;DM Sans-700',],
                        layoutDependency,
                        layoutId: 'hyGu48km1',
                        style: { '--framer-link-text-color': 'rgb(0, 153, 255)', '--framer-link-text-decoration': 'underline', },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/?',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'About',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-zl4be1',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'xNPpLNmjN',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/blog?',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Blog',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-5q6fb8',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'YKhi7dtWI',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'mailto:tommy@holocron.so',
                              openInNewTab: true,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Contact',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-8i6s6a',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'PivakDtuO',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                    ],
                  },),
                  /* @__PURE__ */ _jsxs(motion.div, {
                    className: 'framer-1h9au2r',
                    layoutDependency,
                    layoutId: 'fDShJg9uf',
                    children: [
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy03MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '700',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1em',
                              '--framer-text-alignment': 'center',
                            },
                            children: 'Legal',
                          },),
                        },),
                        className: 'framer-k9rxze',
                        fonts: ['GF;DM Sans-700',],
                        layoutDependency,
                        layoutId: 'bUDx5iY8U',
                        style: { '--framer-link-text-color': 'rgb(0, 153, 255)', '--framer-link-text-decoration': 'underline', },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/privacy?',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Privacy',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-1e8x2iw',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'jsS9lbkj9',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                      /* @__PURE__ */ _jsx2(RichText, {
                        __fromCanvasComponent: true,
                        children: /* @__PURE__ */ _jsx2(React.Fragment, {
                          children: /* @__PURE__ */ _jsx2(motion.p, {
                            style: {
                              '--font-selector': 'R0Y7RE0gU2Fucy01MDA=',
                              '--framer-font-family': '"DM Sans", "DM Sans Placeholder", sans-serif',
                              '--framer-font-size': '14px',
                              '--framer-font-weight': '500',
                              '--framer-letter-spacing': '-0.2px',
                              '--framer-line-height': '1.3em',
                              '--framer-text-alignment': 'center',
                            },
                            children: /* @__PURE__ */ _jsx2(Link, {
                              href: 'holocron.so/terms?x',
                              openInNewTab: false,
                              smoothScroll: false,
                              children: /* @__PURE__ */ _jsx2(motion.a, {
                                className: 'framer-styles-preset-1sbcrqm',
                                'data-styles-preset': 'N4cH5VlsQ',
                                children: 'Terms',
                              },),
                            },),
                          },),
                        },),
                        className: 'framer-1tqs3xg',
                        fonts: ['GF;DM Sans-500',],
                        layoutDependency,
                        layoutId: 'XMt9nORMy',
                        style: { opacity: 0.5, },
                        verticalAlignment: 'top',
                        withExternalLayout: true,
                      },),
                    ],
                  },),
                ],
              },),
            ],
          },),
        },),
      },),
    },),
  },);
},);
var css2 = [
  '@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }',
  '.framer-CH87R.framer-einq92, .framer-CH87R .framer-einq92 { display: block; }',
  '.framer-CH87R.framer-1p2dk03 { align-content: center; align-items: center; display: flex; flex-direction: row; flex-wrap: nowrap; gap: 120px; height: min-content; justify-content: center; max-width: 1600px; overflow: visible; padding: 20px 20px 20px 20px; position: relative; width: 1440px; }',
  '.framer-CH87R .framer-sg7vss { align-content: center; align-items: center; display: flex; flex: 1 0 0px; flex-direction: row; flex-wrap: nowrap; height: min-content; justify-content: space-between; max-width: 1070px; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: 1px; }',
  '.framer-CH87R .framer-1n2n1ru { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; height: 205px; justify-content: space-between; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: min-content; }',
  '.framer-CH87R .framer-lx8aev { align-content: flex-start; align-items: flex-start; align-self: stretch; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 20px; height: min-content; justify-content: center; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: auto; }',
  '.framer-CH87R .framer-r70520-container { flex: none; height: auto; position: relative; width: auto; }',
  '.framer-CH87R .framer-414qf4 { flex: none; height: auto; position: relative; white-space: pre-wrap; width: 290px; word-break: break-word; word-wrap: break-word; }',
  '.framer-CH87R .framer-fhvc5u { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 20px; height: min-content; justify-content: center; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: min-content; z-index: 2; }',
  '.framer-CH87R .framer-1v3h9o6 { flex: none; height: 24px; overflow: visible; position: relative; text-decoration: none; width: 24px; }',
  '.framer-CH87R .framer-16iri5q { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 80px; height: min-content; justify-content: center; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: min-content; }',
  '.framer-CH87R .framer-6cyidk, .framer-CH87R .framer-cm4cza, .framer-CH87R .framer-1h9au2r { align-content: flex-start; align-items: flex-start; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 20px; height: min-content; justify-content: center; overflow: visible; padding: 0px 0px 0px 0px; position: relative; width: min-content; z-index: 2; }',
  '.framer-CH87R .framer-d3ff5u, .framer-CH87R .framer-1h5oztg, .framer-CH87R .framer-k9rxze { cursor: pointer; flex: none; height: auto; position: relative; white-space: pre; width: auto; }',
  '.framer-CH87R .framer-15ohrsh, .framer-CH87R .framer-13i6r7z, .framer-CH87R .framer-zl4be1, .framer-CH87R .framer-5q6fb8, .framer-CH87R .framer-8i6s6a, .framer-CH87R .framer-1e8x2iw, .framer-CH87R .framer-1tqs3xg { --framer-custom-cursors: pointer; flex: none; height: auto; position: relative; white-space: pre; width: auto; }',
  '@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) { .framer-CH87R.framer-1p2dk03, .framer-CH87R .framer-lx8aev, .framer-CH87R .framer-fhvc5u, .framer-CH87R .framer-16iri5q, .framer-CH87R .framer-6cyidk, .framer-CH87R .framer-cm4cza, .framer-CH87R .framer-1h9au2r { gap: 0px; } .framer-CH87R.framer-1p2dk03 > * { margin: 0px; margin-left: calc(120px / 2); margin-right: calc(120px / 2); } .framer-CH87R.framer-1p2dk03 > :first-child, .framer-CH87R .framer-fhvc5u > :first-child, .framer-CH87R .framer-16iri5q > :first-child { margin-left: 0px; } .framer-CH87R.framer-1p2dk03 > :last-child, .framer-CH87R .framer-fhvc5u > :last-child, .framer-CH87R .framer-16iri5q > :last-child { margin-right: 0px; } .framer-CH87R .framer-lx8aev > *, .framer-CH87R .framer-6cyidk > *, .framer-CH87R .framer-cm4cza > *, .framer-CH87R .framer-1h9au2r > * { margin: 0px; margin-bottom: calc(20px / 2); margin-top: calc(20px / 2); } .framer-CH87R .framer-lx8aev > :first-child, .framer-CH87R .framer-6cyidk > :first-child, .framer-CH87R .framer-cm4cza > :first-child, .framer-CH87R .framer-1h9au2r > :first-child { margin-top: 0px; } .framer-CH87R .framer-lx8aev > :last-child, .framer-CH87R .framer-6cyidk > :last-child, .framer-CH87R .framer-cm4cza > :last-child, .framer-CH87R .framer-1h9au2r > :last-child { margin-bottom: 0px; } .framer-CH87R .framer-fhvc5u > * { margin: 0px; margin-left: calc(20px / 2); margin-right: calc(20px / 2); } .framer-CH87R .framer-16iri5q > * { margin: 0px; margin-left: calc(80px / 2); margin-right: calc(80px / 2); } }',
  '.framer-CH87R.framer-v-75wkdn.framer-1p2dk03 { width: 540px; }',
  '.framer-CH87R.framer-v-75wkdn .framer-sg7vss { align-content: flex-start; align-items: flex-start; flex-direction: column; }',
  '.framer-CH87R.framer-v-75wkdn .framer-16iri5q { flex-direction: column; }',
  '@supports (background: -webkit-named-image(i)) and (not (font-palette:dark)) { .framer-CH87R.framer-v-75wkdn .framer-sg7vss, .framer-CH87R.framer-v-75wkdn .framer-16iri5q { gap: 0px; } .framer-CH87R.framer-v-75wkdn .framer-sg7vss > *, .framer-CH87R.framer-v-75wkdn .framer-sg7vss > :first-child, .framer-CH87R.framer-v-75wkdn .framer-sg7vss > :last-child { margin: 0px; } .framer-CH87R.framer-v-75wkdn .framer-16iri5q > * { margin: 0px; margin-bottom: calc(80px / 2); margin-top: calc(80px / 2); } .framer-CH87R.framer-v-75wkdn .framer-16iri5q > :first-child { margin-top: 0px; } .framer-CH87R.framer-v-75wkdn .framer-16iri5q > :last-child { margin-bottom: 0px; } }',
  ...css,
];
var Framerv4r4pVd_q = withCSS(Component, css2, 'framer-CH87R',);
var stdin_default2 = Framerv4r4pVd_q;
Framerv4r4pVd_q.displayName = 'footer';
Framerv4r4pVd_q.defaultProps = { height: 245, width: 1440, };
addPropertyControls(Framerv4r4pVd_q, {
  variant: { options: ['uyOzMAJQy', 'jJWwQuLAJ',], optionTitles: ['desktop', 'mobile',], title: 'Variant', type: ControlType.Enum, },
},);
addFonts(Framerv4r4pVd_q, [
  {
    explicitInter: true,
    fonts: [{
      family: 'DM Sans',
      source: 'google',
      style: 'normal',
      url: 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAkJxhS2f3ZGMZpg.woff2',
      weight: '500',
    }, {
      family: 'DM Sans',
      source: 'google',
      style: 'normal',
      url: 'https://fonts.gstatic.com/s/dmsans/v15/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwARZthS2f3ZGMZpg.woff2',
      weight: '700',
    },],
  },
  ...LogoFonts,
  ...getFontsFromSharedStyle(fonts,),
], { supportsExplicitInterCodegen: true, },);

// virtual:footer
import { WithFramerBreakpoints, } from 'unframer';
import { jsx, } from 'react/jsx-runtime';
stdin_default2.Responsive = (props,) => {
  return /* @__PURE__ */ jsx(WithFramerBreakpoints, { Component: stdin_default2, ...props, },);
};
var footer_default = stdin_default2;
export { footer_default as default, };
